import { margin, width } from '@mui/system';
import React, { useEffect, useState } from 'react';
import DataService from "../common/services/dataService";


const StudyValidationDetails = (props) => {
    const studyId = props.match.params.studyId;
    // main card
    const initialValidationId = props.match.params.validationId;
    const [validations, setValidations] = useState([]);
    const [originalValidation, setOriginalValidation] = useState(null);
    const [originalValidationId, setOriginalValidationId] = useState(null);
    const [alternativeValidation, setAlternativeValidation] = useState(null);
    const [alternativeSelectedValId, setAlternativeSelectedValId] = useState(null)
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [videoUrl, setVideoUrl] = useState("");
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [showPassed, setShowPassed] = useState(true);
    const [showFailed, setShowFailed] = useState(true);


   useEffect(() => {
    const fetchValidationDetails = async (validationId) => {
        try {
            const response = await DataService.getStudyRunThrough(validationId);
            if (response.data?.success && response.data.data) {
                return response.data.data;
            } else {
                throw new Error("Failed to fetch study validations.")
            }
        } catch (err) {
            console.error("Error fetching study validations:", err);
            throw err;
        }
    };

    const fetchValidationsForStudy = async () => {
        try {
            setLoading(true);
            setError(null);

            // Alternative validations list
            const allValidationsResponse = await DataService.getStudyRunThroughs();
            const allValidations = allValidationsResponse.data?.data || [];
            const filteredValidations = allValidations.filter(
                (v) => String(v.study_id) === String(studyId)
            );

            // list sorted by date
            filteredValidations.sort(
                (a, b) => new Date(b.processed_datetime) - new Date(a.processed_datetime)
            );

            setValidations(filteredValidations);

            // loading validation ID
            const mainValidationId = initialValidationId
                ? Number(initialValidationId)
                : filteredValidations.length > 0
                ? filteredValidations[0].id
                : null;

            if (!mainValidationId) {
                setError("No validations available");
                setLoading(false);
                return;
            }

            // fetch validation details
            const mainValidationData = await fetchValidationDetails(mainValidationId);
            setOriginalValidation(mainValidationData);
            setOriginalValidationId(mainValidationId);

            setLoading(false);
        }   catch (err) {
            setError("Error loading validations");
            setLoading(false);
        }
    };

    fetchValidationsForStudy();
   }, [studyId, initialValidationId]);

    // Fetch alternative validation details
    useEffect(() => {
        if (!alternativeSelectedValId) {
            setAlternativeValidation(null);
            return;
        }

        const fetchAlternativeValidation = async () => {
            try {
                setLoading(true);
                const altValData = await DataService.getStudyRunThrough(alternativeSelectedValId);
                if (altValData.data?.success && altValData.data.data) {
                    setAlternativeValidation(altValData.data.data);
                }
                setLoading(false);
            }   catch (err) {
                console.error(err);
                setLoading(false);
            }
        };

        fetchAlternativeValidation();
    }, [alternativeSelectedValId]);

     //render validation card
  const renderValidationCard = (validation, isAlternative = false) => {
    if (!validation) return null;

    return (
        <div>
            
            <div key={validation.id} 
    style={{background: 'white',
        padding: '16px',
        marginBottom: '16px',
        borderRadius: '10px',
        boxShadow: '0 2px 6px rgba(0,0,0,0.5)', borderLeft: `6px solid ${validation.complete ? '#22c55e' : '#ef4444'}`, 
        width: isAlternative ? '100%' : 'auto',
        float: isAlternative ? 'inline-end' : 'none' 
        }}>
            <h3>{validation.name} {isAlternative }</h3>
                <p><strong>Device: </strong>{validation.device}</p>
                <p><strong>Region: </strong>{validation.region}</p>
                <p><strong>Processed: </strong> {new Date(validation.processed_datetime).toLocaleString("en-GB")}</p>
                <p><strong>Status: </strong><span style={{color: validation.complete ? '#09ba4a' : '#ef4444'}}>{validation.complete ? ' ✔ Passed' : ' ❌ Failed'}</span></p>
                {validation.error_msg && <p><strong>Error Message:</strong> {validation.error_msg}</p>}
                {!validation.complete ? (
                   <span  style={{color: 'rgb(99, 115, 129)', pointerEvents: 'none'}}>
                    Video Unavailable 
                </span> 
                ) : (
                    <span rel="noreferrer" style={{ color: '#2563eb', cursor: 'pointer', textDecoration: 'none'}}
                    onClick={() => {
                        setVideoUrl(validation.video_url);
                        setIsModalOpen(true);
                    }}>View Video</span>
                )}
    </div>
        </div>
    
    );
  };
   

  return (
    <div style={{ minHeight: '100vh', background: 'rgb(236, 239, 241)', }}>
        <div style={{ padding: '24px', fontFamily: 'sans-serif', background: '#f6f8fa', borderRadius: '16px' }}>
        <h1 style={{ fontSize: '3rem', fontWeight: '400', marginBottom: '50px', fontFamily: `"Roboto", "Helvetica", "Arial", sans-serif`, lineHeight: '1.167', letterSpacing: '0em', textAlign: 'center' }}>
            Study Validation Overview </h1>
        
        {error && <p style={{color: "red"}}>{error}</p>}
        {loading && <p>Loading...</p>}
   
      {/* details summary */}
      <div style={{ display: 'flex', gap: '24px', flexWrap: 'wrap'}}>
        <div style={{ background: 'white', padding: '20px', borderRadius: '10px', boxShadow: '0 2px 6px rgba(0,0,0,0.5)', flex: '1 1 300px' }}>
            <h2 style={{ fontSize: '18px', marginBottom: '12px'}}>Study Details</h2>
            <p><strong>Study ID</strong> {studyId} </p>
            <p><strong>Total Validations</strong> {validations.length} </p>
        <div style={{marginTop: '20px', top: '17px', position: 'relative'}}>
            <label style={{display: 'block', marginBottom: '8px'}}><strong>Filter Validations:</strong></label>
                <div style={{display: 'flex'}}>
                    <label style={{marginRight: '16px', display: 'flex', width: '100%'}}>
                        <input type="checkbox" checked={showPassed} style={{width: 'fit-content'}}
                            onChange={(e) => setShowPassed(e.target.checked)} 

                        /> <span style={{width: "100%", padding: "9px"}}>Show Passed</span>
                    </label>

                    <label style={{marginRight: '16px', display: 'flex', width: '100%'}}>
                        <input type="checkbox" checked={showFailed} style={{width: 'fit-content'}}
                            onChange={(e) => setShowFailed(e.target.checked)} 
                        /> <span style={{width: "100%", padding: "9px"}}>Show Failed</span>

                    </label>
                </div>
        </div>
      {validations.length > 1 && (
        <div style={{margin: '35px'}}>
            <label><strong>View other Validations by Date:</strong></label>
            <div style={{overflow: 'scroll', height: '45vh', marginTop: '5px'}}>
                <ul style={{listStyle: 'none', padding: '0', marginTop: '8px'}}>
                {validations
                    .filter((item) => 
                        item.id !== originalValidation?.id &&
                        item.study_id === originalValidation?.study_id &&
                        item.device === originalValidation?.device
                ) 
                .filter((item) => {
                    if (item.complete && showPassed) return true;
                    if (!item.complete && showFailed) return true;
                    return false;
                })
                .map((item) => (
                    <li key={item.id} 
                    onClick={() => setAlternativeSelectedValId(item.id)}
                    style={{
                        cursor: 'pointer', 
                        padding: '5px 10px', 
                        height: '30px', 
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        borderRadius: '6px', 
                        backgroundColor: alternativeSelectedValId === item.id 
                            ? '#dbeafe' 
                            : '#f3f4f6',
                        marginBottom: '6px',
                        transition: 'background 0.2s', 
                        borderLeft: `6px solid ${item.complete ? '#22c55e' : '#ef4444'}`,
                        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
                        fontWeight: alternativeSelectedValId === item.id ? 'bold' : 'normal'
                    }}
                    onMouseEnter={e => e.currentTarget.style.backgroundColor = '#f3f4f6'}
                    onMouseLeave={e => e.currentTarget.style.backgroundColor = alternativeSelectedValId === item.id ? '#dbeafe' : '#ffffff'}
                    >
                        <span>{new Date(item.processed_datetime).toLocaleString("en-GB")}</span>
                        <span style={{ fontSize: '0.9rem', color: item.complete ? '#09ba4a' : '#ef4444'}}>
                            {item.complete ? '✔ Passed' : '❌ Failed'}
                        </span>
                    </li> 
                ))}
            </ul>
            </div>
            
        </div>
      )}
     </div>

      {/* Validation results */}
      <div style={{ flex: '2 1 600px'}}>
        {originalValidation ? (
            <>
            
            {renderValidationCard(originalValidation)}

        <h3 style={{marginTop: '40px'}}>Alternative Date:</h3>
            {alternativeSelectedValId && alternativeValidation && (
                <>
                    {renderValidationCard(alternativeValidation, true)}
                </>
            )}
            </>
        ) : (
            <p>No validation results available for this study</p>
        )}
        </div>
        </div>
       {isModalOpen && (
        <div style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          backgroundColor: "rgba(0,0,0,0.6)",
          display: "flex",
          justifyContent: "center",
          alighItems: "center",
          zIndex: 1000,
        }}
        onClick={() => setIsModalOpen(false)}
        >
          <div style={{ position: "relative", width: "80%", maxWidth: "800px", top: "6rem" }}
          onClick={(e) => e.stopPropagation()}
          >
            <video controls autoPlay style={{width: "100%", borderRadius:"8px"}}>
              <source src={videoUrl} type="video/mp4" />
              Your browser does not support the video tag
            </video>
            <button 
            onClick={() => setIsModalOpen(false)}
            style={{
              position: "absolute",
              top: 8,
              right: 8,
              background: "white",
              border: "none",
              borderRadius: "50%",
              cursor: "pointer",
            }}>
              x
            </button>
            </div>
            </div>
      )}
      </div>
       
     </div>
  
      
    );
}

export default StudyValidationDetails